export const Marquee = ({ items = [], className = "" }) => {
  const doubled = [...items, ...items];
  return (
    <div className={`relative overflow-hidden py-6 ${className}`}>
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl font-light tracking-tight px-8">
              {item}
            </span>
            <span className="text-[#2b8a7e] text-3xl md:text-5xl">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
